/* src/app/features/tranches/pesquisa/listagem/tranche-listagem.component.scss */
.table-responsive {
  margin-top: 40px;
}
#pointer :hover {
  cursor: pointer;
}
/*# sourceMappingURL=tranche-listagem.component.css.map */
